// FOOTIE — custom AI-squad-builder mascot icon.
// A stylised 2026-World-Cup-style football: white sphere with red / green / blue
// triangular panels. Drawn from scratch (no Adidas/FIFA product photos).
// `variant="hybrid"` adds a small pencil overlay = FOOTIE-built squad the user edited.
import { Pencil } from "lucide-react";

export function FootieBall({ size = 28, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 64 64"
      className={className}
      role="img"
      aria-label="FOOTIE"
    >
      <defs>
        <radialGradient id="footie-shine" cx="38%" cy="32%" r="75%">
          <stop offset="0%" stopColor="#ffffff" />
          <stop offset="100%" stopColor="#e9eef5" />
        </radialGradient>
      </defs>
      <circle cx="32" cy="32" r="30" fill="url(#footie-shine)" stroke="#0f172a" strokeWidth="2" />
      {/* central pentagon */}
      <polygon points="32,20 41,27 37,38 27,38 23,27" fill="#0f172a" />
      {/* triangular panels */}
      <polygon points="32,20 23,27 18,16 28,12" fill="#dc2626" />
      <polygon points="32,20 41,27 46,16 36,12" fill="#16a34a" />
      <polygon points="41,27 37,38 50,40 52,29" fill="#2563eb" />
      <polygon points="27,38 23,27 12,29 14,40" fill="#16a34a" />
      <polygon points="27,38 37,38 34,50 30,50" fill="#dc2626" />
      {/* seams to the rim */}
      <g stroke="#0f172a" strokeWidth="1.5" fill="none" strokeLinecap="round">
        <line x1="28" y1="12" x2="24" y2="5" />
        <line x1="36" y1="12" x2="40" y2="5" />
        <line x1="52" y1="29" x2="60" y2="27" />
        <line x1="50" y1="40" x2="57" y2="46" />
        <line x1="34" y1="50" x2="36" y2="58" />
        <line x1="30" y1="50" x2="28" y2="58" />
        <line x1="14" y1="40" x2="7" y2="46" />
        <line x1="12" y1="29" x2="4" y2="27" />
      </g>
    </svg>
  );
}

export default function FootieIcon({ size = 28, variant = "pure", className = "" }) {
  if (variant === "hybrid") {
    return (
      <span className={`relative inline-flex ${className}`} aria-label="FOOTIE-built, edited">
        <FootieBall size={size} />
        <span
          className="absolute -bottom-1 -right-1 flex items-center justify-center rounded-full bg-amber-400 text-slate-900 ring-1 ring-slate-900"
          style={{ width: size * 0.5, height: size * 0.5 }}
        >
          <Pencil size={size * 0.3} strokeWidth={3} />
        </span>
      </span>
    );
  }
  return <FootieBall size={size} className={className} />;
}

// Helper: which icon (if any) a leaderboard row should show.
export function footieVariant(row) {
  if (!row?.is_ai_built) return null;
  return (row.ai_picks_modified || 0) > 0 ? "hybrid" : "pure";
}
